import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import "./navbar.css";
import logoh from "../../assets/logoh.png";
import { toast } from "react-toastify";
import ChangePasswordModal from "../../componentes/modal/ChangePasswordModal";
import { cambiarContrasenaUsuario, getReportesNavbar, guardarTipoCAmbio } from "../../service/api";
import TipoCambioModal from "../modal/tipocambio/TipoCambioModal";
import ReportesModal from "../modal/reportes/ReportesModal";

class Navbar extends Component {
  state = {
    userMenuOpen: false,
    catalogMenuOpen: false,

    showTipoCambio: false,
    showreporte: false,
    showChangePass: false,
    passLoading: false,

    role: "", 
    reportesCount: 0,
    reportesLoading: false,
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
    document.addEventListener("keydown", this.handleEsc);
    window.addEventListener("reportes:refresh", this.cargarContadorReportes);


    const datos = localStorage.getItem("sharem");
    if (!datos) {
      this.props.history.push("/");
      return;
    }

    try {
      const datosjson = JSON.parse(datos);
      const role = String(datosjson?.role || "").trim();

      this.setState({ role: role || "Agencia" });

      const first = this.getFirstAllowedRoute(role || "Agencia");
      const current = this.props.location?.pathname || "";
      if (!this.isRouteAllowed(current, role || "Agencia")) {
        this.props.history.replace(first);
      }

      this.cargarContadorReportes();

      this.reportesInterval = setInterval(() => {
        this.cargarContadorReportes();
      }, 8000);

    } catch (e) {
      localStorage.removeItem("sharem");
      this.props.history.push("/");
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleEsc);

    window.removeEventListener("reportes:refresh", this.cargarContadorReportes);

    if (this.reportesInterval) {
      clearInterval(this.reportesInterval);
    }
  }

  // ====== PERMISOS ======
  getRole = () => {
    // prioridad: state.role (ya parseado) y fallback a sharem
    const stateRole = String(this.state.role || "").trim();
    if (stateRole) return stateRole;

    try {
      const raw = localStorage.getItem("sharem");
      const j = raw ? JSON.parse(raw) : {};
      return String(j?.role || "Agencia").trim() || "Agencia";
    } catch {
      return "Agencia";
    }
  };

  cargarContadorReportes = async () => {
    try {
      this.setState({ reportesLoading: true });

      const resp = await getReportesNavbar();

      const lista = Array.isArray(resp?.data)
        ? resp.data
        : Array.isArray(resp)
          ? resp
          : [];

          const pendientes = lista.filter((item) => Number(item?.idestatus) === 1);

          this.setState({
            reportesCount: pendientes.length,
            reportesLoading: false,
          });
    } catch (error) {
      console.error("Error al cargar contador de reportes:", error);

      this.setState({
        reportesCount: 0,
        reportesLoading: false,
      });
    }
  };

  can = (perm) => {
    const role = this.getRole();
    const r = role.toLowerCase();

    if (r === "administrador") {
      if (perm === "facturacion") return true;
      return true;
    }

    if (r === "contador") {
      if (perm === "solicitudes") return true;
      if (perm === "ventas") return true;
      if (perm === "catalogos") return true;
      if (perm === "usuarios") return false;
      if (perm === "tipoCambio") return false;
      if (perm === "facturacion") return true;
      return false;
    }

    if (perm === "solicitudes") return true;
    return false;
  };

  // Define la primera ruta "home" según rol
  getFirstAllowedRoute = (role) => {
    const r = String(role || "").toLowerCase();
    if (r === "administrador") return "/ventas";
    if (r === "contador") return "/ventas";
    return "/solicitudes"; // Agencia
  };

  // si el usuario intenta entrar a rutas directas por URL
  isRouteAllowed = (pathname, role) => {
    const r = String(role || "").toLowerCase();
    const path = String(pathname || "");

    if (r === "administrador") return true;

    if (r === "contador") {
      if (path.startsWith("/solicitudes")) return true;
      if (path.startsWith("/ventas")) return true;
      if (path.startsWith("/facturacion")) return true;
      if (path.startsWith("/productos")) return true;
      if (path.startsWith("/afiliaciones")) return true;
      if (path.startsWith("/locaciones")) return true;
      if (path.startsWith("/nacionalidades")) return true;
      if (path.startsWith("/user")) return false;
      return false;
    }

    if (path.startsWith("/solicitudes")) return true;
    return false;
  };

  // ====== UI HANDLERS ======
  handleEsc = (e) => {
    if (e.key === "Escape") {
      this.setState({
        userMenuOpen: false,
        catalogMenuOpen: false,
        showChangePass: false,
        showTipoCambio: false,
        showreporte: false,
      });
    }
  };

  handleOutsideClick = (e) => {
    if (this.userMenuRef && !this.userMenuRef.contains(e.target)) {
      this.setState({ userMenuOpen: false });
    }
    if (this.catalogMenuRef && !this.catalogMenuRef.contains(e.target)) {
      this.setState({ catalogMenuOpen: false });
    }
  };

  toggleUserMenu = () => {
    this.setState((prev) => ({
      userMenuOpen: !prev.userMenuOpen,
      catalogMenuOpen: false,
    }));
  };

  toggleCatalogMenu = () => {
    // si no tiene permiso de catálogos, no hacemos nada
    if (!this.can("catalogos")) return;

    this.setState((prev) => ({
      catalogMenuOpen: !prev.catalogMenuOpen,
      userMenuOpen: false,
    }));
  };

  goTo = (to) => {
    this.setState({ userMenuOpen: false, catalogMenuOpen: false });
    this.props.history.push(to);
  };

  logout = () => {
    this.setState({ userMenuOpen: false, catalogMenuOpen: false });

    localStorage.removeItem("sharem");
    localStorage.removeItem("datosm");
    localStorage.removeItem("user");

    this.props.history.push("/");
  };

  openChangePassword = () => {
    this.setState({
      showChangePass: true,
      userMenuOpen: false,
      catalogMenuOpen: false,
    });
  };
  // ====== Reportes ======
  openReportes = () => {
    this.setState({
      showTipoCambio: false,
      userMenuOpen: false,
      catalogMenuOpen: false,
      showreporte: true,
    });

    this.cargarContadorReportes();
  };

  closeReportes = () => {
    this.setState({
      showreporte: false,
    });

    this.cargarContadorReportes();
  };

  closeChangePass = () => {
    this.setState({ showChangePass: false, passLoading: false });
  };

  // ====== TIPO CAMBIO ======
  openTipoCambio = () => {
    if (!this.can("tipoCambio")) return;

    this.setState({
      showTipoCambio: true,
      userMenuOpen: false,
      catalogMenuOpen: false,
    });
  };

  closeTipoCambio = () => {
    this.setState({ showTipoCambio: false });
  };

  onSaveTipoCambio = async (payload) => {
    try {
      const resp = await guardarTipoCAmbio(payload);

      // token expirado
      if (resp?.code === 2003) {
        toast.info("Sesión expirada. Inicia sesión nuevamente.");
        this.setState({ showTipoCambio: false });
        this.logout();
        return;
      }

      if (resp?.code !== 0) {
        toast.info(`${resp?.code} - ${resp?.message || "No se pudo guardar el tipo de cambio."}`);
        return;
      }

      toast.success(resp?.message || "Tipo de cambio guardado.");
      this.setState({ showTipoCambio: false });
    } catch (e) {
      toast.info("Error al guardar tipo de cambio.");
    }
  };

  // ====== CAMBIO CONTRASEÑA ======
  onSaveChangePass = async (payload) => {
    this.setState({ passLoading: true });

    try {
      const r = await cambiarContrasenaUsuario(payload);

      if (r?.code === 0) {
        toast.success(r.message || "Contraseña actualizada.");
        this.setState({ passLoading: false, showChangePass: false });
      } else {
        this.setState({ passLoading: false });
        toast.info(`${r?.code} - ${r?.message}`);
      }
    } catch (e) {
      this.setState({ passLoading: false });
      toast.info("Error al cambiar contraseña.");
    }
  };

  render() {
    const {
      userMenuOpen,
      catalogMenuOpen,
      showChangePass,
      showTipoCambio,
      passLoading,
      showreporte,
      reportesCount,
    } = this.state;
    const { location } = this.props;

    // user
    let user = {};
    try {
      const raw = localStorage.getItem("sharem");
      user = raw ? JSON.parse(raw) : {};
    } catch (e) {
      user = {};
      localStorage.removeItem("sharem");
    }

    const userName = user?.nombre || "Usuario";
    const role = this.getRole();
    const homeTo = this.getFirstAllowedRoute(role);

    // tabs visibles según rol
    const tabs = [
      this.can("ventas") ? { to: "/ventas", label: "Ventas" } : null,
      this.can("solicitudes") ? { to: "/solicitudes", label: "Solicitudes" } : null,
      this.can("facturacion") ? { to: "/facturacion", label: "Facturación" } : null,
    ].filter(Boolean);

    const catalogActive =
      location.pathname.startsWith("/catalogos") ||
      location.pathname.startsWith("/productos") ||
      location.pathname.startsWith("/afiliaciones") ||
      location.pathname.startsWith("/locaciones") ||
      location.pathname.startsWith("/nacionalidades") ||
      location.pathname.startsWith("/user");

    return (
      <>
        <ChangePasswordModal
          show={showChangePass}
          user={user}
          loading={passLoading}
          onClose={this.closeChangePass}
          onSave={this.onSaveChangePass}
        />

        <TipoCambioModal
          show={showTipoCambio}
          onClose={this.closeTipoCambio}
          onSave={this.onSaveTipoCambio}
          onLogout={this.logout}
        />


        <ReportesModal
          show={showreporte}
          onClose={this.closeReportes}
        />

        <header className="mm-nav">
          <div className="mm-nav__inner">
            <div className="mm-nav__left">
              <NavLink to={homeTo} className="mm-nav__brand" aria-label="Inicio">
                <img className="mm-nav__logo" src={logoh} alt="Morena Mia Beauty" />
              </NavLink>
            </div>

            <nav className="mm-nav__tabs" aria-label="Secciones">
              {/* CATÁLOGOS: solo si tiene permiso */}
              {this.can("catalogos") && (
                <div className="mm-tabwrap" ref={(ref) => (this.catalogMenuRef = ref)}>
                  <button
                    type="button"
                    className={`mm-tab mm-tab--btn ${catalogActive ? "mm-tab--active" : ""}`}
                    onClick={this.toggleCatalogMenu}
                    aria-haspopup="menu"
                    aria-expanded={catalogMenuOpen}
                  >
                    Catálogos{" "}
                    <span className={`mm-user__chev ${catalogMenuOpen ? "is-open" : ""}`}>▾</span>
                  </button>

                  {catalogMenuOpen && (
                    <div className="mm-submenu" role="menu">
                      {/* Usuarios: SOLO admin */}
                      {this.can("usuarios") && (
                        <button type="button" className="mm-menu__item" onClick={() => this.goTo("/user")}>
                          Usuarios
                        </button>
                      )}

                      {/* Catálogos permitidos a contador/admin */}
                      <button type="button" className="mm-menu__item" onClick={() => this.goTo("/productos")}>
                        Productos
                      </button>

                      <button type="button" className="mm-menu__item" onClick={() => this.goTo("/afiliaciones")}>
                        Afiliaciones
                      </button>

                      <button type="button" className="mm-menu__item" onClick={() => this.goTo("/locaciones")}>
                        Locaciones
                      </button>
                      <button type="button" className="mm-menu__item" onClick={() => this.goTo("/nacionalidades")}>
                        Nacionalidades
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* TABS */}
              {tabs.map((t) => (
                <NavLink key={t.to} to={t.to} className="mm-tab" activeClassName="mm-tab--active">
                  {t.label}
                </NavLink>
              ))}

              {/* TIPO CAMBIO: solo admin (o si activas para contador) */}
              {this.can("tipoCambio") && (
                <button
                  type="button"
                  className={`mm-tab mm-tab--btn ${showTipoCambio ? "mm-tab--active" : ""}`}
                  onClick={this.openTipoCambio}
                  aria-pressed={showTipoCambio}
                >
                  Tipo cambio
                </button>
              )}
            </nav>



            {/* RIGHT: USER MENU */}
            <div className="mm-nav__right" ref={(ref) => (this.userMenuRef = ref)}>

              <button
                type="button"
                className={`mm-tab mm-tab--btn mm-reportes-btn 
                ${showreporte ? "mm-tab--active" : ""} 
                ${reportesCount > 0 ? "mm-reportes-btn--alert" : ""}`}
                onClick={this.openReportes}
                style={{paddingTop:"0px", paddingBottom:"0px"}}
                aria-pressed={showreporte}
              >
                <span>Reporte</span>

                {reportesCount > 0 && (
                  <span className="mm-reportes-badge">
                    {reportesCount > 99 ? "99+" : reportesCount}
                  </span>
                )}
              </button>
              <button
                type="button"
                className="mm-user"
                onClick={this.toggleUserMenu}
                aria-haspopup="menu"
                aria-expanded={userMenuOpen}
              >
                <span className="mm-user__name">{userName}</span>
                <span className={`mm-user__chev ${userMenuOpen ? "is-open" : ""}`}>▾</span>
              </button>

              {userMenuOpen && (
                <div className="mm-menu" role="menu">
                  <button className="mm-menu__item" onClick={this.openChangePassword}>
                    Cambiar contraseña
                  </button>

                  <button className="mm-menu__item mm-menu__item--danger" onClick={this.logout}>
                    Cerrar sesión
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default withRouter(Navbar);